import { type IProjectRentalDispenseItem } from "@/interfaces/api/project-rental-dispense-item.interface"
import { BaseRepository } from "@/repositories/base-repository"

export class ProjectRentalDispenseItemRepository extends BaseRepository<IProjectRentalDispenseItem> {
  protected resourcePath = "administration/projects-rental-dispense-items"
}
